import { apiClient } from "./apiClient";

const auth = (accessToken) => ({ headers: { Authorization: `Bearer ${accessToken}` } });

/** Superadmin: the LLM provider settings (the API key itself is never returned: has_key + key_hint). */
export async function getAiSettings(accessToken) {
  return (await apiClient.get("/ai-settings", auth(accessToken))).data;
}

export async function saveAiSettings(accessToken, body) {
  return (await apiClient.put("/ai-settings", body, auth(accessToken))).data;
}

/** One tiny request to the SAVED provider. */
export async function testAiSettings(accessToken) {
  return (await apiClient.post("/ai-settings/test", {}, auth(accessToken))).data;
}
